import React from "react";
import "./style.css";
import cardImg from "../../../../Assets/Images/card-img.svg";
import { Link } from "react-router-dom";
import leftArrow from "../../../../Assets/Images/v-arrow.svg";
import { isValidString } from "../../../../helper";
import moment from "moment";

const RegisteredProgram = ({ data }) => {
  return (
    <div className="container-fluid programs pad-0 p-0">
      <div className="row m-0">
        <div className="col-lg-12 pad-0 p-0">
          <div className="card program-card border-0 my-4">
            <img
              src={isValidString(data?.image_url) ? data?.image_url : cardImg}
              className="card-img-top rounded-top-0"
              alt="cardImg"
            />
            <div className="card-body">
              <h5 className="card-title">{data?.event_name}</h5>
              <p className="sub-title mb-2">
                {moment(data?.start_date).format("DD MMM YY")} -{" "}
                {moment(data?.end_date).format("DD MMM YY")}
              </p>
              <p className="activity mb-2">
                {data?.activity_count}
                {data?.activity_count > 1 ? "activities" : "activity"}
              </p>
              <Link
                to={data?.is_quiz_only ? "/quiz-program-detail" : `/learning-programs/${data?.event_code}`}
                state={{ eventCode: data?.event_code }}
                className="view-more text-decoration-none"
              >
                View details
                <img src={leftArrow} alt="leftArrow" className="ms-1" />
              </Link>
              <div className="age-detail">
                <p className="mb-0">
                  <b>
                    {data?.min_age === data?.max_age
                      ? data?.max_age
                      : `${data?.min_age}-${data?.max_age}`}
                  </b>
                </p>
                <p className="mb-0">yrs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisteredProgram;
